// Giá trị enum tăng dần giảm dần
export default {
  Asc: 0, //  Tăng dần
  Desc: 1, //  Giảm dần
};
